import mixinGetters from '@/store/mixins/preview/getters'
import mixinActions from '@/store/mixins/preview/actions'
import mixinMutations from '@/store/mixins/preview/mutations'

export default {
	namespaced: true,
	state: {
		activePage: 'start',
		segments: [],
		jumps: [],
		activeSegment: null,
		oldNextSegment: null,
		history: [],
		invalidFields: [],
		answers: {},
	},
	getters: {
		...mixinGetters, 
		...{
			activePage: state => state.activePage,
			activeSegment: state => state.activeSegment,
			editSource (state, getters, rootState, rootGetters) {
				return rootGetters.editSources.survey
			},
			segmentFields: (state, getters, rootState, rootGetters) => (segment) => {
				if (segment.forced) {
					return rootGetters[`surveySection/segmentFields`](segment.fields)
				} else if (segment.is_common) {
					return rootGetters['commonSegment/field/segmentFields'](segment.fields)
				} else {
					return rootGetters['survey/editing/field/segmentFields'](segment.fields)
				}
			}
		}
  },
  mutations: {
		...mixinMutations
  },
  actions: {
		...mixinActions,
	}
}
